// extracted by mini-css-extract-plugin
module.exports = {"P_16":"P_P_16__cMovr"};